import { Box, CircularProgress, Backdrop, Tooltip } from '@mui/material';
import { Card, CardContent, Typography } from '@mui/material';
import DateRangeIcon from '@mui/icons-material/DateRange';
import SchoolIcon from '@mui/icons-material/School';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import MoneyIcon from '@mui/icons-material/Money';
import AttendanceSummary from './Dashboard/AttendanceSummary';
import FeeCollectionProgress from './Dashboard/FeeCollectionProgress';
import GenderActivity from './Dashboard/GenderActivity';
//import AttendanceSlider from './Dashboard/AttendanceSlider';
import { dashboard, getFeesSumary } from '../features/dashboard/dashboardSlice';
import { getClasses } from '../features/classes/ClassSlice';
import ClassWiseEnrollment from './Dashboard/ClassWiseEntrollment';
import ExamResultReport from './Dashboard/ExamResultReports';
import NoticeBoard from './Dashboard/NoticeBoard';
import { LuHandCoins } from 'react-icons/lu';
import { GiPayMoney } from 'react-icons/gi';
import { BsClockHistory } from 'react-icons/bs';
import useNotification from '../hooks/useNotification';
import ToastNotification from './UIElements/ToastNotification';
import OtherFees from './Dashboard/OtherFees';
const DashboardAnalytics = () => {
  const successData = useSelector((state) => state.auth.successData);
  const { logo } = successData;
  let { smsService, userName } = successData.userDetails;
  const [dashboardData, setDashboardData] = useState({});
  const [feesData, setFeesData] = useState('');
  const [loading, setLoading] = useState(true);
  const [classesData, setClassesData] = useState([]);
  const dispatch = useDispatch();
  const { notification, showError, hideNotification } = useNotification();
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        await Promise.allSettled([
          handleDashboardData(),
          handleClasses(),
          handleFeeSummary(),
        ]);
        setLoading(false);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);
  async function handleDashboardData() {
    try {
      const res = await dispatch(dashboard()).unwrap();
      setDashboardData(res);
      return true;
    } catch (error) {
      console.log(error);
      showError('Error in getting Dashboard Details.');
      throw error;
    }
  }
  async function handleClasses() {
    try {
      const data = await dispatch(getClasses()).unwrap();
      Array.isArray(data) ? setClassesData(data) : setClassesData([]);
      return true;
    } catch (error) {
      console.log(error);
      showError('Error in getting Classes Details.');
      throw error;
    }
  }
  async function handleFeeSummary() {
    try {
      const resp = await dispatch(getFeesSumary()).unwrap();
      setFeesData(resp);
      return true;
    } catch (error) {
      console.log(error);
      showError('Error in getting Fee Summary Details.');
      throw error;
    }
  }
  const statsData = [
    {
      Icon: <MoneyIcon />,
      title: 'Total Tution Fee ',
      value: `₹${new Intl.NumberFormat('en-IN').format(feesData?.feeDetails?.[0]?.value ?? '--')}`,
      color: '#2563EB',
      bgColor: '#dbeafe',
    },
    {
      Icon: <LuHandCoins size='24' />,
      title: 'Total Collections',
      value: `₹${new Intl.NumberFormat('en-IN').format(feesData?.feeDetails?.[1]?.value ?? '--')}`,
      color: '#24A192',
      bgColor: 'rgba(36,161,146,0.1)',
    },
    {
      Icon: <MoneyIcon />,
      title: 'Fee Due',
      value: `₹${new Intl.NumberFormat('en-IN').format(feesData?.feeDetails?.[2]?.value ?? '--')}`,
      color: '#F59E0B',
      bgColor: '#fef3c7',
    },
    {
      Icon: <GiPayMoney size='25' />,
      title: 'Write-off',
      value: `₹${new Intl.NumberFormat('en-IN').format(feesData?.feeDetails?.[3]?.value ?? '--')}`,
      color: '#EF4444',
      bgColor: '#fee2e2',
    },
    {
      Icon: <BsClockHistory size='25' />,
      title: 'Pending Due',
      value: `₹${new Intl.NumberFormat('en-IN').format(feesData?.feeDetails?.[4]?.value ?? '--')}`,
      color: '#10B981',
      bgColor: '#d1fae5',
    },
  ];
  function StatCard({ title, value, color, bgColor, Icon }) {
    return (
      <Card className='h-[90px] rounded-xl shadow-[2px_2px_10px_0px_rgba(0,0,0,0.08)]'>
        <CardContent className='flex gap-3 items-start p-[14px]'>
          <Box
            className={`flex items-center justify-center p-[5px] rounded-lg shrink-0`}
            style={{ backgroundColor: bgColor }}
          >
            <Box style={{ color }}>{Icon}</Box>
          </Box>
          <Box className='flex flex-col '>
            <div className=' text-[#272727] xl:text-[18px] leading-tight'>
              {title}
            </div>

            <div className='capitalize font-bold text-[#1e3a8a]  lg:text-lg leading-normal'>
              {value}
            </div>
          </Box>
        </CardContent>
      </Card>
    );
  }
  return (
    <>
      {/* <WhatsAppButton /> */}
      <Box className='relative h-full max-h-full overflow-auto '>
        {loading ? (
          <Backdrop
            open
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: (theme) => theme.zIndex.drawer + 1,
              width: '100%',
              height: '100vh',
            }}
            className='bg-white'
          >
            <div>
              <div className='sticky flex flex-col items-center gap-2 text-center top-1/2'>
                <CircularProgress color='primary' />
                <div className='text-center '>
                  Fetching Dashboard Details...
                </div>
              </div>
              <br />
            </div>
          </Backdrop>
        ) : !dashboardData ? (
          <div className='flex items-center justify-center size-full'>
            <h4> No Data,Error in Fetching Dashboard Detials</h4>
          </div>
        ) : (
          <>
            {!loading && (
              <div className=' bg-[#F8F9FC] min-h-screen  lg:p-4 p-3 rounded'>
                {/* Row1 */}
                <div className='grid grid-cols-1 md:grid-cols-2 min-[800px]:grid-cols-3  xl:grid-cols-[40fr_17fr_17fr_26fr]  mb-2  gap-2  '>
                  {/* Welcome Banner */}
                  <div className='md:col-span-2  min-[800px]:col-span-3 xl:col-span-1 '>
                    <Card className=' flex flex-col gap-2    bg-gradient-to-r from-blue-100 to-blue-300  min-h-[120px] shadow-none rounded-lg  overflow-visible '>
                      {logo ? (
                        <img
                          src={`data:image/jpeg;base64,${logo}`}
                          className=' h-full w-[160px] md:hidden mx-auto object-contain'
                        />
                      ) : (
                        <img
                          src={'/images/SVClassEdge.png'}
                          className=' h-full w-[168px]  md:hidden mx-auto object-contain'
                        />
                      )}
                      <div>
                        <div className='  '>
                          <div className='flex flex-nowrap items-center justify-between pl-2'>
                            <div>
                              <Typography
                                variant='h6'
                                className='capitalize font-bold text-[#1e3a8a]   w-full max-md:text-center'
                              >
                                Welcome back, {userName} 👋
                              </Typography>
                              <Typography className='font-medium text-[#667399]   max-md:text-center'>
                                Everything you need to manage your institution
                                efficiently
                              </Typography>
                            </div>
                            <div className=' min-w-[160px] max-md:hidden'>
                              {logo ? (
                                <img
                                  src={`data:image/jpeg;base64,${logo}`}
                                  className='h-[135px] w-[160px]  object-contain'
                                />
                              ) : (
                                <img
                                  src={'/images/SVClassEdge.png'}
                                  className=' h-[135px] w-[160px] z-10  pr-0 object-contain'
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>{' '}
                  </div>
                  {/* Attendacne Today */}
                  <div className='w-full'>
                    <Card className=' h-[136px] rounded-xl shadow-[2px_2px_10px_0px_rgba(0,0,0,0.08)]'>
                      <CardContent className='pt-6 '>
                        <Box className='text-center'>
                          <Box className='flex gap-[11px] items-center'>
                            <Box className='bg-[#dbeafe] flex items-center justify-center p-[5px] rounded-lg size-10'>
                              <DateRangeIcon className='text-[#2563EB] text-[22px]' />
                            </Box>
                            <div className=' text-left ml-2 text-[#272727] lg:text-lg '>
                              Today Attendance
                            </div>
                          </Box>
                          <Typography className=' text-[#1e3a8a] lg:text-lg font-semibold  text-center'>
                            {dashboardData?.attendance || 0}%
                          </Typography>
                        </Box>
                        {/* <AttendanceSlider
                        value={dashboardData?.attendance || 0}
                      /> */}
                      </CardContent>
                    </Card>
                  </div>
                  {/* Total Students */}
                  <Card className=' w-full h-[136px] rounded-xl shadow-[2px_2px_10px_0px_rgba(0,0,0,0.08)]'>
                    <CardContent className='pt-6 px-[14px]'>
                      <Box className='flex gap-[11px] items-center mb-1'>
                        <Box className='bg-[#fcedf6] flex items-center justify-center p-[5px] rounded-lg size-10'>
                          <SchoolIcon className='text-[#C35D9C]' />
                        </Box>
                        <div className=' text-left ml-2 text-[#272727] lg:text-lg'>
                          Total Students
                        </div>
                      </Box>
                      <Typography className="capitalize font-['Poppins:Bold',sans-serif] text-[#1e3a8a] lg:text-lg text-center font-semibold">
                        {dashboardData?.totalNumberOfStudents}
                      </Typography>
                    </CardContent>
                  </Card>

                  {/* SMS Overview */}
                  <Tooltip
                    sx={{
                      '& .MuiTooltip-tooltip': {
                        backgroundColor: 'white', // amber-500
                        color: 'blue',
                        fontSize: '0.875rem',
                      },
                    }}
                    title={
                      <div className=''>
                        {smsService
                          ? dashboardData?.sms?.smsCount >=
                            dashboardData?.sms?.totalSms
                            ? 'Please Renew the SMS Service'
                            : `${parseInt(
                                dashboardData?.sms?.totalSms
                                  ? (dashboardData?.sms?.smsCount /
                                      dashboardData?.sms?.totalSms) *
                                      100
                                  : 0,
                              )}% Completed`
                          : 'Please contact admin or sales@support to get Service'}
                      </div>
                    }
                  >
                    <Card
                      className={`w-full  border-red-600 h-[136px] rounded-xl shadow-[2px_2px_10px_0px_rgba(0,0,0,0.08)]  ${smsService ? '' : 'blur-[1px]'}   `}
                      style={{
                        backgroundImage:
                          'linear-gradient(136.554deg, rgb(31, 110, 205) 30.308%, rgb(52, 104, 255) 98.315%)',
                      }}
                    >
                      <CardContent className='px-4 pt-3'>
                        <Typography className="capitalize font-['Inter:Semi_Bold',sans-serif] text-[15px] text-white mb-1 font-semibold">
                          SMS Overview
                        </Typography>

                        <Box>
                          <Typography className="font-['Inter:Regular',sans-serif] text-white text-[11px]  font-light ">
                            Total SMS Used
                          </Typography>

                          <Box className='flex items-start justify-between'>
                            <Typography className="font-['Inter:Semi_Bold',sans-serif] text-white   font-semibold">
                              {`${dashboardData?.sms?.smsCount} /
                              ${dashboardData?.sms?.totalSms}`}
                            </Typography>
                            <Typography className="font-['Inter:Regular',sans-serif] text-white">
                              {parseInt(
                                dashboardData?.sms?.totalSms
                                  ? (dashboardData?.sms?.smsCount /
                                      dashboardData?.sms?.totalSms) *
                                      100
                                  : 0,
                              )}
                              %
                            </Typography>
                          </Box>
                        </Box>
                        <Box className='bg-[#e1e4ed]  border-[#f1f3f7] h-[35px]  mt-2 flex gap-[2px] mb-1 p-1'>
                          {Array.from({
                            length: parseInt(
                              dashboardData?.sms?.smsCount /
                                (dashboardData?.sms?.totalSms / 20),
                            ),
                          }).map((_, i) => (
                            <Box
                              key={i}
                              className='h-[27px] flex-1'
                              style={{
                                backgroundImage:
                                  'linear-gradient(150.459deg, rgb(78, 159, 255) 2.1374%, rgb(35, 136, 255) 97.964%)',
                              }}
                            />
                          ))}
                          {Array.from({
                            length:
                              20 -
                              parseInt(
                                dashboardData?.sms?.smsCount /
                                  (dashboardData?.sms?.totalSms / 20),
                              ),
                          }).map((_, i) => (
                            <Box
                              key={i}
                              className='bg-[#f6faff] h-[27px] flex-1'
                            />
                          ))}
                        </Box>
                      </CardContent>
                    </Card>
                  </Tooltip>
                </div>
                {/* Row 2 */}
                <div className='grid grid-cols-1 gap-2 mb-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5'>
                  {statsData?.map((stat, index) => (
                    <div key={index} className='flex-1'>
                      <StatCard {...stat} />
                    </div>
                  ))}
                </div>
                {/*Row 3 */}
                <div className='grid  grid-cols-1 min-[1000px]:grid-cols-3  gap-2 mb-3'>
                  <div className=' '>
                    <FeeCollectionProgress FeeData={feesData} />
                  </div>
                  <div className='  '>
                    <OtherFees />
                  </div>
                  <div className=''>
                    <GenderActivity
                      GenderDetails={dashboardData?.genderOverview}
                      classesData={classesData}
                    />
                  </div>{' '}
                </div>
                {/* Row 4 */}
                <div className='grid  grid-cols-1 min-[1000px]:grid-cols-2  gap-2 mb-3'>
                  <div className=''>
                    <AttendanceSummary classesData={classesData} />
                  </div>
                  <div className=' '>
                    <ClassWiseEnrollment
                      Data={dashboardData?.studentEnrollement}
                    />
                  </div>
                </div>
                {/* Row 5 */}
                <div className='grid  grid-cols-1 min-[900px]:grid-cols-2    gap-2 mb-3'>
                  <div className='min-[900px]:col-span-1 min-w-0 '>
                    <ExamResultReport classesData={classesData} />
                  </div>
                  <div className='min-[900px]:max-w-[400px]'>
                    <NoticeBoard NoticesData={dashboardData?.notices} />
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </Box>
      <ToastNotification
        open={notification.open}
        onClose={hideNotification}
        message={notification.message}
        title={notification.title}
        severity={notification.severity}
        autoHideDuration={notification.autoHideDuration}
        position={notification.position}
      />
    </>
  );
};
export default DashboardAnalytics;

// WhatsAppButton.jsx

// const PHONE = '919398909490'; // Replace with your WhatsApp number (country code + number, no +)
// const MESSAGE = 'Need help';

// export function WhatsAppButton() {
//   return (
//     <a
//       href={`https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`}
//       target='_blank'
//       rel='noopener noreferrer'
//       aria-label='Chat on WhatsApp'
//       style={{
//         position: 'fixed',
//         bottom: '24px',
//         right: '24px',
//         width: '56px',
//         height: '56px',
//         borderRadius: '50%',
//         backgroundColor: '#25D366',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         boxShadow: '0 4px 16px rgba(37, 211, 102, 0.35)',
//         cursor: 'pointer',
//         zIndex: 9999,
//         textDecoration: 'none',
//         transition: 'transform 0.15s ease',
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.transform = 'scale(1.1)';
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.transform = 'scale(1)';
//       }}
//     >
//       <svg
//         xmlns='http://www.w3.org/2000/svg'
//         width='30'
//         height='30'
//         viewBox='0 0 32 32'
//         fill='white'
//       >
//         <path d='M16 2C8.28 2 2 8.28 2 16c0 2.49.67 4.82 1.83 6.83L2 30l7.37-1.79A13.93 13.93 0 0016 30c7.72 0 14-6.28 14-14S23.72 2 16 2zm0 25.5a11.44 11.44 0 01-5.85-1.6l-.42-.25-4.37 1.06 1.1-4.27-.28-.44A11.44 11.44 0 014.5 16C4.5 9.6 9.6 4.5 16 4.5S27.5 9.6 27.5 16 22.4 27.5 16 27.5zm6.27-8.55c-.34-.17-2.02-1-2.34-1.11-.31-.11-.54-.17-.77.17-.22.34-.87 1.11-1.07 1.34-.2.22-.4.25-.74.08-.34-.17-1.44-.53-2.74-1.69-1.01-.9-1.69-2.01-1.89-2.35-.2-.34-.02-.52.15-.69.15-.15.34-.4.51-.6.17-.2.22-.34.34-.57.11-.22.06-.43-.03-.6-.08-.17-.77-1.86-1.06-2.55-.28-.67-.56-.58-.77-.59l-.66-.01c-.22 0-.58.08-.89.4-.31.31-1.17 1.14-1.17 2.79 0 1.64 1.2 3.23 1.37 3.45.17.22 2.36 3.6 5.72 5.05.8.35 1.43.56 1.91.71.8.25 1.54.22 2.12.13.65-.1 2.02-.82 2.3-1.62.28-.79.28-1.47.2-1.62-.08-.14-.31-.22-.65-.39z' />
//       </svg>
//     </a>
//   );
// }
